// removed by extract-text-webpack-plugin
module.exports = {"component":"_1VBzuAojaJ9x_aD4iNOCmX","form":"Ls4sksCld0qAxPVjGhidQ","header":"_1t23l3usdU1-zu25T2VjQ9","helpText":"_20f6WtA4fb8HpVJDoRPewh","message":"_3ktgPMTguQ2jcqM2UsNQ3F","groupStacked":"_1DVGnoB1ILAPUMMUYYDQx3","label":"_2o2zNARSqzgQRKUgAGb-3d","control":"_3wVhYsW9AwhkxA3DGbjNc4","cta":"_1siCtOLKp9VUiu68HQlcHv","btn":"_1UTvu3lwbn8lWlAVfMLQqy"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Login/ForgotUsernameDialog/ForgotUsernameDialog.css
// module id = 1065
// module chunks = 0